module.exports = "../dist/img/product-detail-2-23.ecfe.jpg";